import React from "react";
import { isMobile, useMobileOrientation } from "react-device-detect";
import styles from "./scanErrorWrapper.module.scss";

// Check if there is a valid token
const ScanErrorWrapper = ({
  sessionToken,
  children,
  fullScreen,
}: {
  sessionToken: string;
  children: JSX.Element;
  fullScreen: boolean;
}) => {
  const { isLandscape } = useMobileOrientation();
  const isMobileOnLandscape = isLandscape && isMobile;
  return !sessionToken || sessionToken.length == 0 ? (
    <div data-cy="scanErrorBar" className={styles.scanErrorBar}>
      A Session Token is needed to continue.
    </div>
  ) : (
    <div
      className={
        fullScreen || isMobile
          ? styles.scanViewMainContainerFullScreen
          : styles.scanViewMainContainerNoFullScreen
      }
    >
      {children}
    </div>
  );
};

export default ScanErrorWrapper;
